import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0345930c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-reorder-photo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "df jc-right" }
const _hoisted_5 = { class: "app-reorder-photo__body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close d-icon-close" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-check d-icon-done" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createBlock(_component_app_header, {
          key: 0,
          customTitle: _ctx.caseName,
          class: "header"
        }, {
          "top-left": _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
              class: _normalizeClass(["back-link", { 'link-disabled': _ctx.dataUpdate }])
            }, _hoisted_3, 2)
          ]),
          "top-right": _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: _normalizeClass(["link", { 'link-disabled': _ctx.dataUpdate || _ctx.noChanges }]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDone && _ctx.onDone(...args)))
              }, " Done ", 2)
            ])
          ]),
          _: 1
        }, 8, ["customTitle"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.mainStore.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
              class: _normalizeClass(["back-link", { 'link-disabled': _ctx.dataUpdate }])
            }, _hoisted_8, 2),
            _createElementVNode("a", {
              href: "javascript:void(0);",
              class: _normalizeClass({ 'link-disabled': _ctx.dataUpdate || _ctx.noChanges }),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDone && _ctx.onDone(...args)))
            }, _hoisted_10, 2)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_draggable, _mergeProps({
        modelValue: _ctx.items,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.items) = $event)),
        tag: "transition-group",
        "component-data": {
          tag: 'div',
          class: 'drag-zone',
          type: 'transition-group',
          name: !_ctx.drag ? 'flip-list' : null
        }
      }, _ctx.dragOptions, {
        onStart: _ctx.startDrag,
        onEnd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag = false)),
        "item-key": "id"
      }), {
        item: _withCtx(({element}) => [
          _createVNode(_component_item_photo, {
            photo: element,
            "no-click-action": ""
          }, null, 8, ["photo"])
        ]),
        _: 1
      }, 16, ["modelValue", "component-data", "onStart"])
    ])
  ]))
}